import { render } from "./footerSection.vue?vue&type=template&id=48b25780"
import script from "./footerSection.vue?vue&type=script&lang=js"
export * from "./footerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__